module.exports = __webpack_public_path__ + "static/pattern-graphic.8b34c7e9.svg";